import { ArrowRight, Clock3, PackageCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { formatCad, productVariants, variantPriceCents } from '@/lib/documentServices';

export default function ServiceProductCard({ product }) {
  const variants = productVariants(product);
  const prices = variants.map(variantPriceCents).filter((value) => Number.isFinite(value));
  const minimum = prices.length ? Math.min(...prices) : null;
  const id = product.slug || product.id || product.uuid;
  return (
    <Card className="card-hover h-full border border-[rgba(6,43,26,0.08)] shadow-sm">
      <CardContent className="flex h-full flex-col p-5">
        <div className="flex items-start justify-between gap-4">
          <div className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-[#062B1A] text-white">
            <PackageCheck className="size-5" />
          </div>
          {minimum !== null && (
            <span className="rounded-full border border-[#D4AF37]/35 bg-[#D4AF37]/10 px-3 py-1 text-sm font-semibold text-[#062B1A]">
              {prices.some((price) => price !== minimum) ? `From ${formatCad(minimum)}` : formatCad(minimum)}
            </span>
          )}
        </div>
        <h2 className="mt-5 text-xl font-semibold text-[#062B1A]" style={{ fontFamily: 'var(--font-display)' }}>{product.name || 'Document service'}</h2>
        <p className="mt-2 line-clamp-4 text-sm leading-relaxed text-[#062B1A]/60">{product.short_description || product.description || 'Review service options and processing information.'}</p>
        {(product.processing_information || product.processing_time) && (
          <p className="mt-4 flex items-start gap-2 text-xs text-[#062B1A]/50"><Clock3 className="mt-0.5 size-3.5 shrink-0 text-[#D4AF37]" />{product.processing_information || product.processing_time}</p>
        )}
        <div className="mt-auto pt-5">
          <Link to={`/student/services/${encodeURIComponent(id)}`} className="inline-flex items-center text-sm font-semibold text-[#062B1A] hover:text-[#8A6508]">
            View service <ArrowRight className="ml-1.5 size-4" />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
